export enum QuerySortOrder {
  Ascending = 'ASC',
  Descending = 'DESC',
}
